(function() {
	PM.Docs = {};

	var SECTIONS = ['plan', 'absences', 'people', 'projects'];

	PM.Docs.renderSection = function(activeId) {
		$.when(
			ejs.preloadTemplate('/app/docs/templates/section.ejs'),
			ejs.preloadTemplate('/app/docs/templates/overview.ejs'),
			ejs.preloadTemplate('/app/docs/plan/plan.ejs'),
			ejs.preloadTemplate('/app/docs/absences/absences.ejs'),
			ejs.preloadTemplate('/app/docs/people/people.ejs'),
			ejs.preloadTemplate('/app/docs/projects/projects.ejs')
		).done(function() {
			$('.js-page-container').html(ejs.rr('/app/docs/templates/section.ejs', {
				sections: SECTIONS,
				active: activeId || null
			}));
		});
	};

	PM.Docs.renderDocsPage = function() { PM.Docs.renderSection(null); };

	page('/docs', PM.Docs.renderDocsPage);
	page('/docs/plan', function() { PM.Docs.renderSection('plan'); });
	page('/docs/absences', function() { PM.Docs.renderSection('absences'); });
	page('/docs/people', function() { PM.Docs.renderSection('people'); });
	page('/docs/projects', function() { PM.Docs.renderSection('projects'); });
})();
